import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'integrations'),
  uk: createLocale(uk, 'integrations'),
  pl: createLocale(pl, 'integrations'),
  ru: createLocale(ru, 'integrations'),
  es: createLocale(es, 'integrations'),
  uz: createLocale(uz, 'integrations'),
  hi: createLocale(hi, 'integrations'),
};

export default locales;
